import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FactorFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FACTOR' htmlFor='number-factor' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='factor'>
          {({ field }) => (
            <Form.InputNumber {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='number-factor' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FactorFormGroup)
